// extracted by mini-css-extract-plugin
export default {"root":"OperationsContent_root__XmLy0"};